import React from 'react';
import { UniverseModuleType } from 'src/domains/common/universes.type';
import { features } from './betstgeorge.features';
import { themeColors } from './betstgeorge.config';
import { BetStGeorgeLogotype } from './betstgeorge.logotype';
import { BetStGeorgeLogo } from 'src/layouts/LoginPage/logos/BetStGeorgeLogo';
import BetStGeorgeLoginImage from 'src/layouts/LoginPage/loginBgImages/BetStGeorgeLoginImage.png';
import { BetStGeorgeBrandIconWrapper, CompliancePopupLogo } from './betstgeorge.style';
import { LoginImageWrapper } from 'src/layouts/LoginPage/LoginImage.style';

export const universeModule: UniverseModuleType = {
    themeColors,
    features,
    title: 'Bet St George Backoffice',
    urls: {
        website: 'https://betstgeorge.com/',
        backoffice: 'https://backoffice.betstgeorge.com/',
    },
    BrandIcon: () => <BetStGeorgeBrandIconWrapper />,
    Logotype: () => <BetStGeorgeLogotype />,
    LogotypeLoginPage: () => <BetStGeorgeLogo />,
    compliancePopupLogo: () => <CompliancePopupLogo />,
    loginImageContainer: () => <LoginImageWrapper imgSrc={BetStGeorgeLoginImage} />,
};
